const queryString = require('query-string');
export default function QueryString(query) {
    return queryString.parse(query);
}
